import type { ListType } from '../models/app';

export const subsidyTypes: ListType[] = [
  { id: 1, key: 'cash', label: 'Cash' },
  { id: 2, key: 'miles', label: 'Miles' },
  { id: 3, key: 'percent', label: 'Percent' },
  { id: 5, key: 'split-cash', label: 'Split (Cash)' },
  { id: 4, key: 'custom', label: 'Custom' },
];

export const subsidyConditionTypes: ListType[] = [
  { id: 1, key: 'all', label: 'All' },
  { id: 2, key: 'locationStartAndEnd', label: 'Location Start and End' },
  { id: 3, key: 'locationStartOrEnd', label: 'Location Start or End' },
  { id: 4, key: 'operator', label: 'Operator' },
  { id: 5, key: 'approvedMemberAddressesAnd', label: 'Approved Member Addresses And' },
  { id: 6, key: 'approvedMemberAddressesOr', label: 'Approved Member Addresses Or' },
];

export const subsidyRenewTypes: ListType[] = [
  { id: 1, key: 'day', label: 'Day' },
  { id: 2, key: 'week', label: 'Week' },
  { id: 3, key: 'month', label: 'Month' },
  { id: 4, key: 'year', label: 'Year' },
];

export const specialPartnerCodes: string[] = ['sanleandro', 'hamv', 'pace', 'Immanuel', 'fresno'];

export const partnerCodesForUberAssist = ['lacostaglen'];

/** New subsidy framework flag: null = old code, config = old code + new UI, on = new code only */
export const newSubsidyOptions: ListType[] = [
  { id: 1, key: '', label: 'Off (old code)' },
  { id: 2, key: 'config', label: 'Config (old code + new UI)' },
  { id: 3, key: 'on', label: 'On (new code only)' },
];
